export const productName = 'MINERAL PROCESSING TEACHER READY';
export const productShortName = 'Mineral Processing Teacher Ready';
export const productImage = 'https://cdn.magicpatterns.com/uploads/ra8C2CAmMu6TntoowAcbrP/MOCKUP_(2).png';

export const checkoutUrl = 'https://mineral-processing-teacher-ready.impultienda.ar/checkout';

export const price = 'USD 27.00';
export const priceBefore = 'USD 80.00';

export const totalVolumes = 9;
export const totalBonuses = 5;
export const bonusTotalValue = 'USD 70.00';

export const included = [
  'Volume 1 — Mineral Processing Fundamentals',
  'Volume 2 — Crushing, Grinding & Comminution',
  'Volume 3 — Screening, Classification & Particle Size Separation',
  'Volume 4 — Gravity Separation & Magnetic Separation',
  'Volume 5 — Froth Flotation & Mineral Concentration',
  'Volume 6 — Dewatering, Thickening & Filtration',
  'Volume 7 — Mineral Processing Plant Operations & Optimization',
  'Volume 8 — Industrial Safety, Environmental Management & Sustainability',
  'Volume 9 — Teaching Mineral Processing',
  'Bonus 1 — 150 Classroom Activities & Technical Exercises',
  'Bonus 2 — Mineral Processing Teacher Assessment Kit',
  'Bonus 3 — 100 Case Studies & Problem-Solving Scenarios',
  'Bonus 4 — Mineral Processing Teacher Dictionary: 200 Essential Concepts',
  'Bonus 5 — Mineral Processing Teacher Lesson Planning Guide (30 Lesson Structures)',
  '7-day money-back guarantee',
  'Instant access',
];

export const systemNegatives = [
  "It's not outdated theory copied from old textbooks.",
  "It's not a collection of disconnected activities.",
  "It's not material you'll need to completely rewrite.",
];

export const closingLines = [
  'No more sleepless nights searching for ways to explain complex mineral processing concepts',
  "No more rushed lessons with materials that don't work",
  "No more disconnected students who don't see mineral processing's relevance",
  'No more weekends spent building lesson plans from scratch',
  "No more awkward silences when students ask technical questions you weren't ready for",
];
